import { categories } from "@/mocks/siteData";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Explore Categories
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Browse through our organized Superbuy Spreadsheet categories. Each category contains verified product links handpicked from trusted sellers.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative flex flex-col rounded-2xl bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-300 hover:-translate-y-1 cursor-pointer overflow-hidden"
            >
              {idx === 0 && (
                <span className="absolute top-3 left-3 z-10 px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold">
                  Popular
                </span>
              )}
              <div className="relative h-36 md:h-40 overflow-hidden">
                <img
                  src={cat.image}
                  alt={`${cat.name} - Superbuy Spreadsheet`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute top-3 right-3 w-9 h-9 rounded-xl bg-background-50/80 backdrop-blur-sm flex items-center justify-center group-hover:bg-accent-100 transition-colors">
                  <i className={`${cat.icon} text-base text-accent-600`}></i>
                </div>
              </div>
              <div className="p-4 text-center">
                <span className="text-sm md:text-base font-semibold text-foreground-900 leading-tight">
                  {cat.name}
                </span>
                <span className="block text-xs text-foreground-500 mt-1">
                  {cat.linkCount} links
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}